import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: '/',  // Replace with your API base URL
});

// Set the Authorization header with Bearer token
const setAuthToken = (token) => {
  if (token) {
    // If a token is provided, set it in the request header
    axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
  } else {
    // If no token, remove the Authorization header
    delete axiosInstance.defaults.headers['Authorization'];
  }
};

const readFromToken = (field: string) => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  if (!field) return token;

  const decodedToken = jwtDecode(token) as any;
  return decodedToken[field];
};

enum UserRoles {
  UNAUTHORIZED_COMMANDER = 0,
  AUTHORIZED_COMMANDER = 1,
  UNAUTHORIZED_DOCTOR = 2,
  AUTHORIZED_DOCTOR = 3
};


export { axiosInstance, setAuthToken, readFromToken, UserRoles };
